import { DataContainer } from '@otto-ec/tracking-bct';
import { Logger } from './logger';

export class TrackingDataExtractor {
    public static extractTrackingData(targetElement: Element, dataAttributeName: string): DataContainer | null {
        const trackingData = targetElement.getAttribute(dataAttributeName);
        if (trackingData) {
            try {
                return JSON.parse(trackingData);
            } catch (_e: unknown) {
                Logger.logError({ message: `cant parse tracking data: ${trackingData}` });
            }
        }
        return null;
    }
}
